import { api } from "@/utils/axios";

export const noticeService = {
  announcement_lists(body: any) {
    return api.post<PageResponseData>("/Announcement/announcement_lists", body);
  },
  announcement_detail(body: any) {
    return api.post<PageResponseData>("/Announcement/announcement_detail", body);
  }
};
